/**
 * Optimized Quick Filter Pills - Proxy Version
 * Automatically syncs with theme filter drawer
 */
(function() {
  const SELECTORS = {
    pill: 'quick-filter-pill',
    pillContainer: '.quick-filter-sidebar-menu-wrapper',
    filtersForm: '[data-filters-form]',
    collectionProducts: '[data-collection-products]',
    overlay: '#quickFilterOverlay'
  };

  class QuickFilterPills {
    constructor() {
      this.init();
    }

    init() {
      this.bindEvents();
      this.highlightActivePills();
      this.setupObserver();
      
      // Secondary highlight check for race conditions
      setTimeout(() => this.highlightActivePills(), 500);
    }

    bindEvents() {
      // Use document-level delegation to handle dynamic elements
      document.addEventListener('click', (e) => {
        const pill = e.target.closest(SELECTORS.pill);
        if (!pill) return;

        console.log('Pill clicked:', pill.innerText.trim());
        const param = pill.getAttribute('quick-data-add');
        const value = pill.getAttribute('quick-data-id');

        if (param && value) {
          this.toggleFilter(param, value);
        }
      });

      // Handle back/forward browser buttons
      window.addEventListener('popstate', () => {
        setTimeout(() => this.highlightActivePills(), 100);
      });
    }

    toggleFilter(param, value) {
      this.showOverlay();

      // 1. Try to find the real checkbox in the theme's filter drawer
      // We look for name/value match. We decode values to handle multiple encoding styles.
      const searchTerms = [value, decodeURIComponent(value)];
      const searchParam = [param, decodeURIComponent(param)];
      
      let realInput = null;
      
      for (const p of searchParam) {
        for (const v of searchTerms) {
          realInput = document.querySelector(`input[name="${p}"][value="${v}"]`);
          if (realInput) break;
        }
        if (realInput) break;
      }

      if (realInput) {
        console.log('Found matching checkbox in drawer, clicking it.');
        realInput.click();
        // The theme's native JS handles the AJAX and URL update from here.
        // Our MutationObserver will handle the cleanup.
      } else {
        console.warn('Matching checkbox not found in drawer. Falling back to URL update.');
        this.fallbackUrlToggle(param, value);
      }
    }

    fallbackUrlToggle(param, value) {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      
      const currentValues = params.getAll(param);
      const decodedTarget = decodeURIComponent(value);
      
      const exists = currentValues.some(v => v === value || decodeURIComponent(v) === decodedTarget);

      params.delete(param);
      if (exists) {
        currentValues.filter(v => v !== value && decodeURIComponent(v) !== decodedTarget)
                     .forEach(v => params.append(param, v));
      } else {
        currentValues.forEach(v => params.append(param, v));
        params.append(param, value);
      }

      params.delete('page');
      window.location.href = url.toString();
    }

    highlightActivePills() {
      const params = new URLSearchParams(window.location.search);
      const pills = document.querySelectorAll(SELECTORS.pill);

      pills.forEach(pill => {
        const param = pill.getAttribute('quick-data-add');
        const value = pill.getAttribute('quick-data-id');
        if (!param || !value) return;

        const decodedValue = decodeURIComponent(value);
        const isActive = params.getAll(param).some(v => 
          v === value || decodeURIComponent(v) === decodedValue
        );

        if (isActive) {
          pill.classList.add('quickFilter--active');
        } else {
          pill.classList.remove('quickFilter--active');
        }
      });
    }

    setupObserver() {
      // The theme replaces [data-collection-products] content on every AJAX load
      const grid = document.querySelector(SELECTORS.collectionProducts);
      if (grid) {
        const observer = new MutationObserver(() => {
          console.log('Grid updated, refreshing pills...');
          this.highlightActivePills();
          this.refreshPillsMarkup();
          this.hideOverlay();
        });
        observer.observe(grid, { childList: true });
      }
    }

    async refreshPillsMarkup() {
      // Fetch fresh HTML to update the pills (since they contain liquid logic for availability)
      try {
        const response = await fetch(window.location.href);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newWrapper = doc.querySelector(SELECTORS.pillContainer);
        const currentWrapper = document.querySelector(SELECTORS.pillContainer);
        
        if (newWrapper && currentWrapper) {
          currentWrapper.innerHTML = newWrapper.innerHTML;
          this.highlightActivePills();
        }
      } catch (e) {
        console.error('Failed to refresh pills markup:', e);
      }
    }

    showOverlay() {
      const overlay = document.querySelector(SELECTORS.overlay);
      if (overlay) overlay.classList.add('active');
    }

    hideOverlay() {
      const overlay = document.querySelector(SELECTORS.overlay);
      if (overlay) overlay.classList.remove('active');
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { window.QuickFilterPills = new QuickFilterPills(); });
  } else {
    window.QuickFilterPills = new QuickFilterPills();
  }
})();